import React from "react";
import { ShiftCancelReason } from "oneclick-component/src/store/apis/enhancedApi";

export interface ShiftListContextValue {
  activeShiftListLength: number;
  setActiveShiftListLength: (shiftLength: number) => void;
  shiftCancelReasons: ShiftCancelReason[];
}

export const ShiftListContext = React.createContext<ShiftListContextValue>(
  null as any
);
